import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import cn from "classnames";
import {
  TFBPMatchingItem,
} from "@api/apiClient/fbp";
import { FilterModel } from '@hooks/useFiltersSearchParams';
import { Title2, SubTitle3 } from '@components/new/Typo';
import { MarketplaceStoreGroup } from "@components/new/MarketplaceStoreGroup";
import { Marketplace } from "@components/new/Marketplace";
import { IconButton, IconButtonSize, IconButtonType } from "@components/new/IconButton";
import EditIcon from "@assets/icons/outline/square-pen.svg?react";
import styles from "./MatchingItem.module.scss";

export interface IMatchingItemProps {
  data: TFBPMatchingItem;
  filters?: FilterModel[];
  onEdit: (value: TFBPMatchingItem) => void;
}

const MatchingItem = ({ onEdit, data }: IMatchingItemProps): ReactElement => {
  const { t } = useTranslation();

  const wbCount = data.wbProducts?.length ?? 0;
  const ymCount = data.ymProducts?.length ?? 0;
  const aliCount = data.aliProducts?.length ?? 0;

  return (
    <div className={styles.matchingItem}>
      <div className={styles.content}>
        <MarketplaceStoreGroup>
          {wbCount ? <Marketplace name="Wildberries" /> : null}
          {ymCount ? <Marketplace name="Yandex" /> : null}
          {aliCount ? <Marketplace name="Aliexpress" /> : null}
        </MarketplaceStoreGroup>
        <div className={cn(styles.contentItem, styles.contentItemLeft)}>
          <Title2 ellipsis lines={2}>{data.name}</Title2>
        </div>
        <SubTitle3 className={cn(styles.contentItem, styles.contentItemRight)}>
          {t("fbpPage.matchings.articles", { count: wbCount + ymCount + aliCount })}
        </SubTitle3>
      </div>
      <IconButton
        icon={EditIcon}
        onClick={() => onEdit(data)}
        size={IconButtonSize.L}
        type={IconButtonType.ICON}
      />
    </div>
  );
};

export default MatchingItem;
